import { DialogContent, DialogTitle } from '@mui/material';

import React from 'react';
import {
  DialogHeader,
  DraggableTooltipContainer,
} from 'spw-components/worksheet/styles';
import {
  CenteredSpaceBetweenRow,
  SPWClickAwayTooltip,
} from 'spw-shared/globalComponents';
import { MarginTop16 } from 'spw-shared/globalComponents/containers';
import { useSelector } from 'react-redux';
import { selectMeasurementSystem } from 'spw-redux/modules/user/selectors';
import { MeasurementSystem } from 'spw-components/unit-conversion/types';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import { DialogContentText, DialogContentHeader } from './styles';

const ESTIMATED_WIDTH = 298;
const ESTIMATED_HEIGHT = 554;

export const CalculationAssumptionsDialog = () => {
  const { getUnit } = useUnitConversion();
  const measurementSystem = useSelector(selectMeasurementSystem);
  return (
    <SPWClickAwayTooltip height={ESTIMATED_HEIGHT} width={ESTIMATED_WIDTH}>
      <DraggableTooltipContainer>
        <DialogTitle id="draggable-dialog-title" className="title">
          <CenteredSpaceBetweenRow>
            <DialogHeader>Calculation Assumptions</DialogHeader>
          </CenteredSpaceBetweenRow>
        </DialogTitle>
        <DialogContent className="content">
          <DialogContentHeader>DIMENSIONS AND UNIT SIZE</DialogContentHeader>
          <DialogContentText>
            {measurementSystem === MeasurementSystem.imperial
              ? `These inputs for File Cabinets and Lockers are measured in inches
        instead of feet for more precision.`
              : `Dimension inputs are in mm to allow for more precision. Unit size inputs are in M.`}
          </DialogContentText>

          <MarginTop16 />

          <DialogContentHeader>TOTAL {getUnit('area')}</DialogContentHeader>
          <DialogContentText>
            {measurementSystem === MeasurementSystem.imperial ? (
              <>
                <span>
                  Dimensions and Unit Sizes convert from inches to feet in order
                  to be included accurately within the program since all other
                  spaces are measured in feet.
                </span>
                <br />
                <br />
              </>
            ) : null}
            Total {getUnit('area')} has been multiplied by 2 to account for file
            drawer and locker door clearances when open.
          </DialogContentText>

          {measurementSystem === MeasurementSystem.imperial ? (
            <>
              <MarginTop16 />
              <DialogContentHeader>Example:</DialogContentHeader>
              <DialogContentText>
                DIMENSIONS and UNIT SIZE
                <br />
                18 in W x 25 in D = 450 sq in
                <br />
                450 sq in / 144 = 3.125 sq ft
              </DialogContentText>
              <DialogContentText>
                TOTAL {getUnit('area')}
                <br />
                3.125 sq ft x 10 qty = 31.25 sq ft
                <br />
                31.25 x 2 = 62.5 total sq ft
              </DialogContentText>
            </>
          ) : null}
        </DialogContent>
      </DraggableTooltipContainer>
    </SPWClickAwayTooltip>
  );
};
